import { useTitle } from '@flippingbook/web.react-hooks/dist/useTitle';
import { Button } from '@flippingbook/web.react-kit/dist/Button';
import { Paper } from '@flippingbook/web.react-kit/dist/Paper';

import { useSelectSamlProviderPage } from '@/hooks/useSelectSamlProviderPage';
import { loc } from '@/localization';
import { Field } from '@/site/components/Field';
import { Link } from '@/site/components/Link';

import { b, e } from '../Login/style.css';

export function SelectSamlProviderPage() {
    useTitle(loc.Main.AccountPageTitle.replace('{0}', loc.Login.SsoLoginTitle));

    const { loginUrl, register, errors, cleanErrors, isSubmitting, onFormSubmit } = useSelectSamlProviderPage();

    return (
        <div className={b.name}>
            <Paper
                className={e.card}
                radius="large"
            >
                <h1 className={e.title}>{loc.Login.SsoLoginTitle}</h1>
                <p className={e.subtitle2}>{loc.Login.SsoLoginDescription}</p>
                <form
                    className={e.form}
                    onSubmit={onFormSubmit}
                    noValidate
                >
                    <Field
                        className={e.emailField}
                        name="idp"
                        type="text"
                        placeholder={loc.Login.SsoIdProviderPlaceholder}
                        onChange={cleanErrors}
                        register={register}
                        errors={errors}
                        readOnly={isSubmitting}
                        autoFocus
                    />
                    <div className={e.buttons}>
                        <Button
                            className={e.submitButton}
                            type="submit"
                            theme="green"
                            size="large"
                            progress={isSubmitting}
                            disabled={isSubmitting}
                        >
                            {loc.Login.DoSsoLogin}
                        </Button>
                    </div>
                </form>
                <div className={e.footer}>
                    <Link to={loginUrl}>{loc.Login.DoPasswordLogin}</Link>
                </div>
            </Paper>
        </div>
    );
}
